import type { RouteLocationNormalizedGeneric } from 'vue-router';

export function useCurrentSectionConfig(to?: RouteLocationNormalizedGeneric) {
    const route = to ?? useRoute();
    const nuxtApp = useNuxtApp();
    const language = useLanguage(to);
    const countryLanguages = useCountryLanguages();

    return computed(() => {
        const registry = nuxtApp.$subSectionRegistry?.value;
        if (!registry) return null;

        const urlSegment = language?.urlSegment?.value ?? '';
        const country = language?.country?.value ?? '';
        const lang = language?.lang?.value ?? '';

        return findCurrentSectionConfig(registry, route.path, urlSegment, country, lang, countryLanguages);
    });
}
